module.exports = __webpack_public_path__ + "static/img/zzrz03.1e8c12f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zzrz03.jpg
// module id = JTpC
// module chunks = 1